module.exports = __webpack_public_path__ + "af34c7112b8a688624ae782dc745dff3.MP3";